module.exports = __webpack_public_path__ + "img/4_60.1ad40d6b.png";